<template>
	<div class="container">
		<div v-if="isDownloading" class="downloading-bar">
			<div class="download-content">
				<el-progress customClass="download-progress" class="download-progress" :width="40" type="circle" :percentage="getDownloading.progress"></el-progress>
				<div class="download-title">{{(getDownloading.preparing)?$l('main/preparingFile'):$l('main/downloadingFile')}} </div>
			</div>
		</div>
		<div class="header" :class="isDownloading?'header-downloading':''">
			<div @click="menuOnClick" class="menu-icon" :title="$l('calendar/title')">
				<i class="el-icon-menu"></i>
			</div>
			<div style="float:right" class="header-right">
				<!--<router-link to="settings"> <el-button type="large" class="settingsMenu el-icon-setting"> </el-button> </router-link>
				<router-link to="login"> <el-button type="large" class="settingsMenu el-icon-setting"> </el-button> </router-link> -->

				<!-- Ti si ubadu s poravnano, mislim... popover za menu lol... tuki mas popover, vspodi je pa dropdown menu
					<el-popover
						ref="archives-button-popover"
						placement="bottom"
						width="200"
						trigger="click">
						<play-popover></play-popover>
					</el-popover>

					<div class="el-icon-document settingsMenu" v-popover:archives-button-popover>
					</div>
				-->

				<div :title="$l('main/titleStatistics')" class="download-button" @click="onStatisticsClick()"><icon name="line-chart"> </icon></div> <!-- class download-button spremen, al pa ne ce je sam za css -->

				<div  :title="$l('main/titleManual')" @click="goToManual()" class="download-button"><icon name="question"></icon></div>

				<el-popover ref="download-button-popover" placement="bottom" width="150" trigger="click"><download-popover></download-popover></el-popover>
				<div v-if="$p('download')" :title="$l('main/titleDownload')" v-show="showDownloads" v-popover:download-button-popover class="download-button"><icon name="download"> </icon></div>

				<el-popover ref="archives-button-popover" placement="bottom" width="150" trigger="click"><archive-popover></archive-popover></el-popover>
				<div v-if="$p('archives')" :title="$l('main/titleArchives')" v-bind:class="{'menu-icon-enabled':isArchives}" v-popover:archives-button-popover class="archives-button el-icon-document"></div>

				<el-popover ref="stream-button-popover" placement="bottom" width="300" trigger="click"><stream-popover></stream-popover></el-popover>
				<div v-if="$p('streamPopover/enabled')" :title="$l('main/titleStream')" class="stream-button" v-popover:stream-button-popover><icon name="volume-up"></icon></div>

				<el-popover
					ref="play-button-popover"
					placement="bottom"
					width="150"
					trigger="click">
					<play-popover></play-popover>
				</el-popover>
				<div v-if="$p('realtime')" :title="$l('main/titleRealtime')" @click="toggleRealtime" :class="{'realtime-enabled':getRealtimeEnabled}" class="realtime-button el-icon-time"> </div>
				<div v-if="$p('measurement/enabled')" :title="(playButtonClass.danger)?$l('main/titleDanger'):((playButtonClass.warning)?$l('main/titleWarning'):$l('main/titlePlay'))" class="play-button" v-bind:class="playButtonClass" v-popover:play-button-popover>
					<div class="play-button-inside"></div>
				</div>
				<div v-if="$p('settings/enabled')" :title="$l('main/titleSettings')" v-bind:class="{'menu-icon-enabled':isSettings}" class="settings-button el-icon-setting" @click="navigateToSettings()"></div>

				<div :title="$l('main/titleLogout')" class="logout-button" @click="logoutClicked()"><icon name="sign-out"> </icon></div>
			</div>

		</div>
		<div class="main" :class="isDownloading?'main-downloading':''">
			<calendar-container v-bind:screenSize="screenSize" v-bind:sidebarVisible="sidebarVisible"></calendar-container>
			<div v-bind:class="contentClassname" >
				<div v-if="statusMessage" class="top-error-message">{{
					$l('errors/'+statusMessage.split(":")[0])+(statusMessage.indexOf(':')>-1?(": "+$l('codes/'+statusMessage.split(":")[1])):'')}}</div>
				<div v-if="sdStatusMessage" class="top-error-message">
					{{$l('main/titleSD')}}<span> {{roundDecimal}}% </span> ({{$l('settings/status/of')}} 2 Gb)</div>
				<div v-if="hddStatusMessage" class="top-error-message">{{$l('main/titleHDD')}}<span> {{roundDecimalHDD}}% </span></div>

				<router-view></router-view>
			</div>
		</div>

	</div>
</template>



<script>
import {mutateLocalSettings} from '@/common/utils'
import { mapGetters, mapActions } from 'vuex'
import {setSidebarVisible, getSystemStatus, getLocalSettings, saveLocalSettings, getSettings, getUser, logoutUser, saveUser, setScreenSize} from '@/store/actions';
import ArchivePopover from './ArchivePopover';
import PlayPopover from './PlayPopover';
import DownloadPopover from './DownloadPopover';
import StreamPopover from './StreamPopover';
import Calendar from '../calendar/Calendar';
import CalendarContainer from '../calendar/CalendarContainer';

export default {
	data(){
		return {
			//xs=0,sm=1,md=2,lg=3
			screenSize:3,
			sidebarVisible: true,
			test: true,
		}

	},
	computed:{
		...mapGetters([
			'getStatus',
			'getSystemStatus',
			'getRealtimeEnabled',
			'getSettingsDevice',
			'getSettingsSystem',
			'getUser',
			'getSettingsAddons',
			'getDownloading',
			'getLocalSettings'
		]),
		isDownloading: function(){
			return this.getDownloading.enabled;
		},
		contentClassname: function(){
			return 'content'+((this.screenSize > 1 && this.sidebarVisible)?' sidebar-visible': '');
		},
		showDownloads:function(){
			return this.$route.fullPath == '/' && !this.getRealtimeEnabled;
		},
		roundDecimal:function(){
			return Math.round((100 - this.getSystemStatus.n140_sd_percent) * 10) / 10;
		},
		roundDecimalHDD: function(){
			return Math.round((100 - this.getSystemStatus.hdd_percent) * 10) / 10;
		},
		isSizeBelowLimit: function(){
			return this.roundDecimal <= parseInt(this.getSettingsDevice.sdfreelimit);
		},
		isHddSizeBelowLimit: function(){
			return this.roundDecimalHDD <= parseInt(this.getSettingsSystem.pchddlimit);
		},
		playButtonClass:function(){
			var isError =  (this.getStatus.weatherError || this.getStatus.noiseError || this.getStatus.adioError);
			return {
				danger:(!this.getStatus.noise && !this.getStatus.weather && !this.getStatus.adio)|| isError,
				warning:(!this.getStatus.noise || !this.getStatus.weather || !this.getStatus.adio) && !isError,
				ok:(this.getStatus.noise && (this.getStatus.weather || this.getStatus.adio)) && !isError

			}
		},
		isSettings: function(){ return this.$route.fullPath.indexOf('settings') > -1;},
		isArchives: function(){ return this.$route.fullPath.indexOf('archives') > -1;},
		statusMessage: function(){
			return (this.getStatus.noiseCode)?
				"n140:"+this.getStatus.noiseCode:(
					(this.getStatus.weatherCode)?
					"weather:"+this.getStatus.weatherCode:(
						this.getStatus.adioCode)?"adio:"+this.getStatus.adioCode:(
							this.getSystemStatus.cam_sd_percent > 80)?'cameraSD':'');
		},
		sdStatusMessage: function(){
			if(this.statusMessage)
				return false
			return this.isSizeBelowLimit;
		},
		hddStatusMessage: function(){
			if(this.statusMessage || this.sdStatusMessage )
				return false
			return this.isHddSizeBelowLimit;
		},
		statusSidebar: function(){
		   return this.statusMessage?'error':(this.playButtonClass.ok)?'running':(this.playButtonClass.danger)?'notRunning':(this.playButtonClass.warning)?'running':'notRunning';
		}
	},
	components:{
		'calendar':Calendar,
		'calendar-container': CalendarContainer,
		'play-popover': PlayPopover,
		'download-popover':DownloadPopover,
		'stream-popover':StreamPopover,
		'archive-popover':ArchivePopover
	},
	watch:{
		'$mq.resize' : 'screenResize',
		getStatus: function(newStatus){},
		'$route':function(route){
			if(route.fullPath == '/'){
				this.sidebarVisible = true;
				setSidebarVisible(this.$store, this.sidebarVisible);
			}
			if(route.fullPath.indexOf('realtime')>-1){
				this.setRealtimeEnabled(true);
			}else{
				this.setRealtimeEnabled(false);
			}
		},
		getSettingsSystem: function(settings){
			document.title = 'Noise2Net » '+settings.hostname;
		}
	},
	methods:{
		...mapActions([
		   'setRealtimeEnabled',
		   'getFirmware',
		   'setDownloading',
		   'getDefaultMarkers'
		]),
		screenResize(){
			if(this.$mq.below(768)){
				this.screenSize=0;
				this.sidebarVisible = false;
			}else if(this.$mq.above(1199)){
				this.screenSize=3;
			}
			else if(this.$mq.above(991)){
				this.screenSize=2;
			}
			else if(this.$mq.above(766)){
				this.screenSize=1;
				this.sidebarVisible = false;
			}
			setScreenSize(this.$store, this.screenSize);
			setSidebarVisible(this.$store, this.sidebarVisible);
		},
		menuOnClick(){
			this.sidebarVisible = !this.sidebarVisible;
			setSidebarVisible(this.$store, this.sidebarVisible);
			if(this.screenSize < 2){
				window.scrollTo(0,0);
			}
		},

		navigateToSettings(){
			this.sidebarVisible = !this.sidebarVisible;
			setSidebarVisible(this.$store, this.sidebarVisible);
			if(this.$route.fullPath.indexOf('/settings/')> -1){
				this.$router.push('/');
			}else{
				this.$router.push("/settings/interface");

			}
		},
		toggleRealtime(){
			if(this.getRealtimeEnabled)
				this.$router.push('/');
			else
				this.$router.push('/realtime');
			//setRealtimeEnabled(this.$store, !this.getRealtimeEnabled);
			//this.$router.push('/realtime');
		},
		systemStatusReload(){
			getSystemStatus(this.$store);
			setInterval(()=>{
				getSystemStatus(this.$store);
			},5000)
		},
		handleLocalSettings(){
			var vueInstance = this;
			return new Promise((resolve, reject)=>{
				this.getFirmware()
					.then(data=>{
						return data.epoch;
					}).catch(err=>{
						return Math.random();
					})
					.then(version=>{
						var localSettingsVersion = vueInstance.$localStorage.get('settingsV', 1);
						var localSettings = vueInstance.$localStorage.get('settings', false);
						var isValid = true;
						try{
							localSettings = JSON.parse(localSettings);
						}catch(err){isValid = false;}

						if(!localSettings || !isValid || localSettingsVersion != version ){
							getLocalSettings(vueInstance.$store)
								.then(settings=>{
									mutateLocalSettings(settings, this.screenSize);
									//vueInstance.$localStorage.set('settings', JSON.stringify(settings));
									saveLocalSettings(vueInstance.$store, vueInstance.$localStorage, settings);
									resolve(localSettings);
								})
								.catch(err=>{
									reject(err);
								})
						}else{
							saveLocalSettings(vueInstance.$store, vueInstance.$localStorage, localSettings)
							resolve(localSettings);
						}
					})

			})
		},
		handleRemoteSettings(){
			getSettings(this.$store)
				.then((settings)=>{
					//saveSettings(this.$store, settings);
					this.loading = false;
					//settings received
				})
		},
		goToManual(){
			window.open("/manual/");
		},
		logoutClicked(){
			this.$localStorage.set('useraccount', '');
			logoutUser(this.$store)
				.then(()=>{
					this.$router.push('/login');
				})
		},
		onStatisticsClick(){
			if(this.getSettingsAddons.statistics == 1){
				if(this.$route.path.indexOf('/statistics')  > -1){
					this.$router.push('/');
				}else{
					this.$router.push('/statistics');
				}
			}
		}

	},
	beforeMount: function(){

		if(this.$route.fullPath.indexOf('realtime')>-1){
			if(!this.$p('realtime')){
				return;
				this.$router.push('/');
			}
			this.setRealtimeEnabled(true);
		}else{
			this.setRealtimeEnabled(false);
		}

		 if(!this.getUser.username){
			var useraccount = this.$localStorage.get('useraccount');
			if(useraccount)
			{
				useraccount  = JSON.parse(useraccount);
				if(!useraccount.username){
					this.$router.push('/login');
					return
				}
				//useraccount.type = 'guest'
				saveUser(this.$store, useraccount);
			}else{
				this.$router.push('/login');
				return
			}

		}
	},
	mounted: function(){
		this.screenResize();
		this.handleLocalSettings()
			.then(()=>{
				this.handleRemoteSettings()
			})
			.catch(()=>{})
			.then(()=>{
				this.getDefaultMarkers()
					.then(markers=>{
						markers.forEach(m=>{
						if (this.getLocalSettings.markers) {
							if (!this.getLocalSettings.markers.find(i=> i.id == m.id)){
								this.getLocalSettings.markers.push({
								id: m.id,
								name: m.name,
								color: m.color,
								type: m.type=='Toggle',
								keyCombo: {
									key: '1',
									modifier: 'alt'
								}
								})
							}
						}
						})

						saveLocalSettings(this.$store, this.$localStorage, this.getLocalSettings);
					})
			})
		

//getSystemStatus(this.$store);
		this.systemStatusReload();
	}
}
</script>

<style>
	.top-error-message{
		text-align: center;
		padding-top: 5px;
		padding-bottom: 5px;
		background-color: #e43a45;
		color: white;
	}
	span.red{
		color:#e43a45;
	}
	.fa-icon {
	width: auto;
	height: 1.1em; /* or any other relative font sizes */

	/* You would have to include the following two lines to make this work in Safari */
	max-width: 100%;
	max-height: 100%;
	}
	.el-icon-upload2{
		transform: rotate(180deg);
	}
	.archives{
		font-size: 18px;
		padding: 9px;
		float:left;
	}
	.archivesDropDown
	{
		text-align:center;
	}
	.header{
		background-color: #2b3643;
		height:40px;
		width:100%;
		position: fixed;
		z-index: 15;
		margin-top: -40px;
		color:#95A5A6
	}
	.header-right{
		float: right;
	}
	.download-button{
		font-size: 18px;
		float:left;
		margin-top: 9px;
		margin-right: 10px;
	}
	.download-button:hover{
		color: #1BBC9B;
	}

	.logout-button{
		font-size: 20px;
		float: left;
		margin-top: 8px;
		margin-right: 10px;
		margin-left: 30px;
	}
	.logout-button:hover{
		color: #1BBC9B;
	}

	.stream-button{
		font-size: 18px;
		float:left;
		margin-top: 9px;
		margin-left: 3px;
		margin-right: 5px;
	}
	.stream-button:hover{
		color: #1BBC9B;
	}

	.archives-button {
		font-size: 19px;
		float:left;
		margin-top: 9px;
		margin-left: 5px;
		margin-right: 10px;
	}
	.archives-button:hover{
		color: #1BBC9B;
	}
	.settings-button{
		font-size: 19px;
		float:left;
		margin-top: 9px;
		margin-left: 15px;
		margin-right: 5px;
	}
	.settings-button:hover{
		color: #1BBC9B;
	}


	.realtime-enabled{
		color: #1BBC9B;
	}



	.play-button{
		font-size: 25px;
		margin-top: 9px;
		height:15px;
		width: 15px;
		float: left;
		border-radius: 100%;
		border: 2px solid #95A5A6;
	}
	.play-button-inside{
		background-color: #95A5A6;
		border-radius: 100%;
		width: 7px;
		height: 7px;
		margin-top: 4px;
		margin-left: 4px;
	}
	.play-button:hover .play-button-inside{
		background-color: #1BBC9B;
	}

	.play-button.warning{
		border-color:#f3c200;
	}
	.play-button.warning .play-button-inside{
		background-color:#f3c200;
	}
	.play-button.danger{
		border-color:#e43a45 ;
	}
	.play-button.danger .play-button-inside{
		background-color:#e43a45 ;
	}

	.play-button.ok{
		border-color:#1BBC9B;
	}
	.play-button.ok .play-button-inside{
		background-color:#1BBC9B;
	}



	.play-button:hover{
		border-color:#1BBC9B;
	}

	.menu-icon{
		font-size: 25px;
		float: left;
		padding: 5px;
	}
	.menu-icon:hover{
		color:#1BBC9B;
	}

	.menu-icon-enabled{
		color: #1BBC9B;
	}

	.realtime-button{
		font-size: 18px;
		padding: 9px;
		float:left;
		margin-right:10px;
	}
	.realtime-button:hover{
		color:#1BBC9B;
	}
	.settingsMenuArchives{
		font-size:18px;
		color:#95A5A6;
		float:left;
	}
	.settingsMenuArchives:hover{
		color:white;
	}
	.settingsMenu{
		background-color:#2b3643;
		color:#95A5A6;
		border-width:0px;
		float:left;
	}
	.settingsMenu:hover{
		color:white;
	}
	.main{
		margin-top: 40px;
	}
	/*MD sidebar*/
	.sidebar{
		position: fixed;
		background-color: #364150;
		width:280px;
		top:40px;
		bottom: 0px;
		left: 0px;
	}
	.sidebar-calendar{
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 50px;
	}
	.sidebar-info{
		position: absolute;
		bottom: 0px;
		left:0px;
		right:0px;
		height:50px;
		background-color: #2b3643;
	}
	.sidebar-info-value{
		position: absolute;
		top: 30%;
		left:50%;
		transform: translate(-50%,-50%);
		text-align: center;
		color:#ddd;
		width:100%;

		font-size: 12px;
	}
	.sidebar-status-value{
		position: absolute;
		top: 75%;
		left:50%;
		transform: translate(-50%,-50%);
		text-align: center;
		color:#ddd;
		width:100%;


	}
	/*SM sidebar*/
	.sidebar-top-container{
		background-color: #364150;
		padding: 10px;
		overflow: hidden;

		position: fixed;
		width: 100%;
		z-index: 11;
	}
	.sidebar-top{
	}
	.sidebar-top-calendar{
		position: relative;
	}
	.sidebar-top-info{
		position: relative;
		margin-top: 1px;
		height:50px;
		background-color: #2b3643;
	}
	.content{
		background-color:#ffffff;
		min-height:calc( 100vh - 40px);

	}
	.content.sidebar-visible{
		margin-left:280px;
	}

	.downloading-bar{
		position: fixed;
		height:40px;
		background-color: #4C87B9;
		width: 100%;
		top: 0px;
		z-index: 30;
		text-align: center;
		padding-top: 0px;
		color: white;
	}

	.header-downloading{
		margin-top:0px;
	}

	.main-downloading{
		padding-top: 40px;
	}

	.download-title{
		float: left;
		padding-top: 10px;
		padding-right: 10px;
	}

	.download-progress{
	}

	.download-progress .el-progress-circle__track{
		fill:transparent;
		stroke: transparent;
	}

	.download-progress .el-progress__text{
		 font-size: 10px !important;
		 color:white;
	}

	.download-progress .el-progress-circle__path{
		stroke-width: 10px;
		stroke: #E7505A ;
	}

	.download-content{
		width: fit-content;
		margin-left: auto;
		margin-right: auto;
	}

	::-webkit-scrollbar-button{ display: none; height: 13px; border-radius: 0px; background-color: #AAA; } ::-webkit-scrollbar-thumb{ background-color:#22313F; } ::-webkit-scrollbar-thumb:hover{ background-color: #CCC; } ::-webkit-scrollbar-track{ background-color: transparent; } ::-webkit-scrollbar-track:hover{ background-color:transparent; } ::-webkit-scrollbar{ width: 10px; }
</style>



// WEBPACK FOOTER //
// Main.vue?69448ff0